import './polyfills';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React, { Suspense, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import store from './store';

import App from './components/App';
import LoadingSpinner from 'components/UIComponents/LoadingSpinner';

import './index.scss';
import { refreshSession } from './api/authService';
import { onRefreshSessionSuccess } from './utils/keycloakUtils';

window.store = store;

const Main = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { authenticated, expiresAt } = await refreshSession();
        if (authenticated && !!expiresAt) {
          localStorage.setItem('authenticated', authenticated);
          localStorage.setItem('expiresAt', expiresAt);
        } else {
          localStorage.removeItem('authenticated');
          localStorage.removeItem('expiresAt');
        }
      } catch (error) {
        localStorage.removeItem('authenticated');
        localStorage.removeItem('expiresAt');
      } finally {
        onRefreshSessionSuccess();
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return <LoadingSpinner loading={true} position="global" />;
  }

  return (
      <Provider store={store}>
        <Suspense fallback={<LoadingSpinner loading={true} position="global" />}>
          <App />
        </Suspense>
      </Provider>
  );
};

ReactDOM.render(<Main />, document.getElementById('root'));

serviceWorker.unregister();
